import React, {useEffect, useRef, useState} from 'react';
import {WdiSelect, WdiSelectFormat, WdiTreeSelect} from '@/components/WdiControls/WdiSelect';
import {Form, message} from 'antd';
import {ResponseStatus} from '@/utils/request';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {Product, ProductUom} from '@/services/mdm/product';
import {ProFormInstance} from '@ant-design/pro-form';
import {FieldProps, wdiCore, WdiModalAppProps} from '@/components/WdiControls';
import {FieldConfig, getEcFieldsValue} from '@/components/WdiBus/EcFieldConfig';
import {HorzLayoutOpts, WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {FormSa} from '@/services/sales/sa';
import {getDetailPrevData, paymentMethodDataLoading} from '../../components/data';
import moment from 'moment';
import {
  PRODUCT_BY_QTY_LEVELS, PRODUCT_BY_QTY_DISABLED_LEVELS, ecFields,
  buildFormItem, buildEcFormItem, convertEcFieldConfigs, isNeedProductFg, showCompany,
} from "@/pages/sales/sa/GeneralActivityApply/components/DetailBase";
import {Company} from "@/services/mdm/company";
import {SoldTo} from "@/services/mdm/soldto";

const DetailPosQtySellinPriceApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [ecFieldConfigs, setEcFieldConfigs] = useState<Record<string, FieldConfig>>();
  const [pmOpts, setPmOpts] = useState<any[]>();
  const [expandKeysProduct, setExpandKeysProduct] = useState<string[]>();
  const [paymentMethodId, setPaymentMethodId] = useState(0);
  const [productBuyIds, setProductBuyIds] = useState<string>();

  const {formSaDetail, formSa, rowIndex, rows} = props.data;

  const handlePaymentMethodChange = (value: number) => {
    if (wdiCore.Object.IsNullOrUndefined(value)) {
      setPaymentMethodId(0);
    } else {
      setPaymentMethodId(value);
      if (showCompany(value)) {
        const companyCodeVal = formRef.current?.getFieldValue("companyCode");
        if (!companyCodeVal) {
          SoldTo.get(formSaDetail.soldToCode).then(resp => {
            formRef.current?.setFieldsValue({companyCode: resp.data.companyCode});
          });
        }
      }
    }
  }

  useEffect(() => {
    if (formSaDetail) {
      formRef.current?.setFieldsValue({
        formSaDetailIdOriginal: formSaDetail.formSaDetailIdOriginal,
        paymentMethodId: formSaDetail.paymentMethodId,
        amount: formSaDetail.amount,
        boName: formSaDetail.boName,
        ecName: formSaDetail.ecName,
        revenueTypeName: formSaDetail.revenueTypeName,
        companyCode: formSaDetail.companyCode,
        soldToName: wdiCore.String.Join(formSaDetail.soldToCode, formSaDetail.soldToName),
        remark: formSaDetail.remark,
      });
      if (!wdiCore.Object.IsNullOrUndefined(formSaDetail.unitExpenseSoldTo)) {
        formRef.current?.setFieldsValue({unitExpenseSoldTo: formSaDetail.unitExpenseSoldTo});
      }
      handlePaymentMethodChange(formSaDetail.paymentMethodId);

      if (formSaDetail.activityStartDate) {
        formRef.current?.setFieldsValue({
          activityDate: [
            moment(formSaDetail.activityStartDate),
            moment(formSaDetail.activityEndDate),
          ]
        });
      }

      if (formSaDetail.supplyStartDate) {
        formRef.current?.setFieldsValue({
          supplyDate: [
            moment(formSaDetail.supplyStartDate),
            moment(formSaDetail.supplyEndDate),
          ]
        });
      }

      //支付方式根据所选的费用项和售达方类型构造，若只有一个支付方式自动埴入
      if (formSaDetail.ecId) {
        paymentMethodDataLoading(formSaDetail.ecId).then(paymentMethods => {
          setPmOpts(paymentMethods.map((item) => {
            return {value: item.value, label: item.name};
          }));
          if (paymentMethods.length === 1) {
            formRef.current?.setFieldsValue({paymentMethodId: paymentMethods[0].value});
            handlePaymentMethodChange(paymentMethods[0].value);
          }
        });
      }

      if (formSaDetail.extendFieldsSa || formSaDetail.revExtendFieldsSa) {
        convertEcFieldConfigs(formSaDetail.extendFieldsSa, formSaDetail.revExtendFieldsSa).then(response => {
          setEcFieldConfigs(response);
        });
      }
      if (formSaDetail.productBuyIds) {
        Product.searchAll({
          productIds: formSaDetail.productBuyIds,
          isActive: true
        }).then(response => {
          if (response && response.data) {
            const products = response.data;
            setExpandKeysProduct(products.map(item => `${item.productId}`));
            formRef.current?.setFieldsValue({
              productBuyIds: products.map(item => ({value: item.productId, label: item.codeOrName}))
            });
            setProductBuyIds(products.map(item => item.productId).join(","));
          }
        });
        handleProductBuyChange(formSaDetail.productBuyIds).then();
      }
      if (isNeedProductFg(formSaDetail.paymentMethodId) && formSaDetail.productFgIds) {
        Product.get(formSaDetail.productFgIds).then(response => {
          if (response && response.data) {
            formRef.current?.setFieldsValue({
              productFgIds: {value: response.data.productId, label: response.data.codeOrName}
            });
          }
        });
      }
    }
  }, [formSaDetail]);

  useEffect(() => {
    if (ecFieldConfigs && formSaDetail) {
      Object.keys(ecFieldConfigs).map(key => {
        if (ecFieldConfigs[key].contain) {
          if (ecFields[key] && ecFields[key].set) {
            ecFields[key].set(formSaDetail, formRef);
          } else if (!wdiCore.Object.IsNullOrUndefined(formSaDetail[key])) {
            formRef.current?.setFieldsValue({[key]: formSaDetail[key]});
          }
        }
      });
    }
  }, [ecFieldConfigs, formSaDetail]);

  const handleProductBuyChange = async (productBuyId: any) => {
    const fieldsValues: any = {
      quantityConvert: null,
    };
    const productId = WdiSelectFormat.getvalue(productBuyId);
    if (!wdiCore.Object.IsNullOrUndefined(productId)) {
      fieldsValues.quantityConvert = await getProductUom(productId);
    }
    formRef.current?.setFieldsValue(fieldsValues);
    calculateAmount();
  }


  const getProductUom = async (productBuyId: any) => {
    const response = await ProductUom.getProductUomMin(productBuyId);
    if (response.data && response.data.quantityConvert && response.data.quantityConvert > 1) {
      return response.data.quantityConvert;
    } else {
      return 1;
    }
  }

  // 计算列：原供货价-促销供货价，不可修改
  // 计算列：预计出货销量 * 原供货价; 2位小数；不为空；revenue_sellin_forecast
  // 计算列：单位补差金额*预计出货销量，2位小数
  // 计算列：申请金额/预计出货销售额，分母为空或0则为空，百分比后2位
  const calculateAmount = () => {
    const fieldsValues = {
      unitExpenseMin: null,
      unitExpense: null,
      revenuePosForecast: null,
      amount: null,
      roiForecast: null
    };
    const {
      pricePosBefore,
      pricePosAfter,
      unitExpenseSoldTo,
      quantityPosForecast,
      executionRateForecast,
      quantityConvert
    } = formRef.current?.getFieldsValue();
    if (!wdiCore.Object.IsNullOrUndefined(pricePosBefore)
      && !wdiCore.Object.IsNullOrUndefined(pricePosAfter)) {
      fieldsValues.unitExpenseMin = wdiCore.Number.ToNumber((pricePosBefore - pricePosAfter - (unitExpenseSoldTo ?? 0)), 2);
      if (!wdiCore.Object.IsNullOrUndefined(quantityConvert)) {
        fieldsValues.unitExpense = wdiCore.Number.ToNumber((pricePosBefore - pricePosAfter - (unitExpenseSoldTo ?? 0)) * quantityConvert, 2);
      }
    }
    if (!wdiCore.Object.IsNullOrUndefined(quantityPosForecast)
      && !wdiCore.Object.IsNullOrUndefined(pricePosAfter)
      && !wdiCore.Object.IsNullOrUndefined(quantityConvert)) {
      fieldsValues.revenuePosForecast = wdiCore.Number.ToNumber(quantityPosForecast * pricePosAfter * quantityConvert, 2);
    }
    if (!wdiCore.Object.IsNullOrUndefined(fieldsValues.unitExpense)
      && !wdiCore.Object.IsNullOrUndefined(quantityPosForecast)
      && !wdiCore.Object.IsNullOrUndefined(executionRateForecast)) {
      fieldsValues.amount = wdiCore.Number.ToNumber(Number(fieldsValues.unitExpense) * quantityPosForecast * executionRateForecast, 2);
    }
    if (fieldsValues.amount && fieldsValues.revenuePosForecast) {
      fieldsValues.roiForecast = wdiCore.Number.ToNumber(fieldsValues.amount / fieldsValues.revenuePosForecast, 4);
    }
    formRef.current?.setFieldsValue(fieldsValues);
  }

  return (
    <>
      <WdiModalForm
        {...HorzLayoutOpts}
        formRef={formRef}
        initialValues={{executionRateForecast: 1, unitExpenseSoldTo: 0}}
        title={props.title}
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose?.()
          },
        }}
        onFinish={async (values) => {
          const ecFieldValues = getEcFieldsValue(ecFieldConfigs, ecFields, values);
          const entity: API.FormSaDetail = {
            paymentMethodId: values.paymentMethodId,
            unitExpenseSoldTo: values.unitExpenseSoldTo,
            amount: values.amount,
            remark: values.remark
          };

          entity.productBuyIds = WdiSelectFormat.getvalue(values.productBuyIds);
          if (isNeedProductFg(paymentMethodId)) {
            entity.productFgIds = WdiSelectFormat.getvalue(values.productFgIds);
          }
          entity.companyCode = WdiSelectFormat.getvalue(values.companyCode);

          if (wdiCore.Object.IsNullOrUndefined(values.amount)) {
            message.error("申请金额不能为空!");
            return;
          }
          if (values.activityDate && values.activityDate.length == 2) {
            entity.activityStartDate = moment(values.activityDate[0]).format('YYYY-MM-DD');
            entity.activityEndDate = moment(values.activityDate[1]).format('YYYY-MM-DD');
          }
          if (values.supplyDate && values.supplyDate.length == 2) {
            entity.supplyStartDate = moment(values.supplyDate[0]).format('YYYY-MM-DD');
            entity.supplyEndDate = moment(values.supplyDate[1]).format('YYYY-MM-DD');
          }

          const response = await FormSa.Buttons.validateDetail({
            rowIndex: rowIndex,
            formSa: {...formSa},
            form: {...props.data.form},
            formSaDetail: Object.assign({}, getDetailPrevData(formSaDetail), entity, ecFieldValues),
            formSaDetails: rows
          });
          if (response.code !== ResponseStatus.SUCCESS) {
            message.error(response.message);
            return;
          }
          if (props.onSave) {
            response.data = Object.assign({}, {rowIndex: rowIndex}, response.data);
            props.onSave(response);
          }
        }}
      >
        {buildFormItem("formSaDetailIdOriginal")}
        {buildFormItem("soldToName")}
        {buildEcFormItem("shopId", {fieldConfig: ecFieldConfigs?.["shopId"], soldToCode: formSaDetail.soldToCode})}
        {buildFormItem("activityDate")}
        {buildFormItem("supplyDate")}

        <Form.Item name="productBuyIds" label="产品别" rules={[{required: true, message: '产品别不能为空!'}]}>
          <WdiTreeSelect {...{
            multiple: false,
            placeholder: "请选择产品别",
            defaultExpandKeys: expandKeysProduct,
            dataLoading: async (params) => {
              const response = await Product.searchAll(
                Object.assign({
                  productLevels: PRODUCT_BY_QTY_LEVELS.join(),
                  budgetProjectId: formSa.budgetProjectId,
                  isActive: true,
                  withPermissions: true,
                }, params)
              );
              const {treeData, dict} = FieldProps.TreeSelect.formatTreeData({
                textField: "codeOrName",
                valueField: "productId",
                id: "productId",
                pId: "parentId",
                level: "productLevel",
                disabledLevel: PRODUCT_BY_QTY_DISABLED_LEVELS,
              }, response.data);
              return {treeData, dict};
            },
            onExSelect: (value: any, node: any, dict: any) => {
              const values = formRef.current?.getFieldValue("productBuyIds");
              const rtv = FieldProps.TreeSelect.labeledValuesMeger(dict, values, {value});
              formRef.current?.setFieldsValue({productBuyIds: rtv});
              setProductBuyIds(WdiSelectFormat.getvalue(rtv));
              handleProductBuyChange(rtv).then();
            },
            reloadKey: `${formSaDetail.soldToCode}`
          }} />
        </Form.Item>

        {buildEcFormItem("ip", {fieldConfig: ecFieldConfigs?.["ip"], productIds: productBuyIds})}

        <Form.Item name="quantityConvert" hidden={true}>
          <WdiInputNumber readOnly/>
        </Form.Item>
        <Form.Item
          name="paymentMethodId" label="支付方式"
          rules={[{required: true, message: '支付方式不能为空!'}]}>
          <WdiSelect {...{
            placeholder: "请选择支付方式",
            options: pmOpts,
            onChange: (value) => {
              handlePaymentMethodChange(value);
            }
          }} />
        </Form.Item>
        {showCompany(paymentMethodId) && (
          <Form.Item
            name="companyCode" label="付款公司"
            rules={[{required: true, message: '付款公司不能为空!'}]}
          >
            <WdiSelect
              {...{
                placeholder: '请选择公司',
                showSearch: true,
                dataLoading: async (params) => {
                  const response = await Company.search(Object.assign({
                    isActive: true,
                  }, params));
                  return response?.data?.map(item => ({value: item.companyCode, label: item.codeOrName}));
                },
                reloadKey: paymentMethodId,
              }}
            />
          </Form.Item>
        )}

        {buildFormItem("productFgIds", {
          paymentMethodId: paymentMethodId,
          productFgIds: formSaDetail?.productFgIds,
          budgetProjectId: formSa.budgetProjectId
        })}
        <Form.Item
          name="pricePosBefore" label="原零售价(中包)"
          hidden={!ecFieldConfigs?.["pricePosBefore"].contain}
          rules={[{required: ecFieldConfigs?.["pricePosBefore"].req, message: '原零售价(中包)不能为空!'}]}>
          <WdiInputNumber min={0} onChange={() => {
            calculateAmount();
          }}/>
        </Form.Item>
        <Form.Item
          name="pricePosAfter" label="促销零售价(中包)"
          hidden={!ecFieldConfigs?.["pricePosAfter"].contain}
          rules={[{required: ecFieldConfigs?.["pricePosAfter"].req, message: '促销零售价(中包)不能为空!'}]}>
          <WdiInputNumber min={0} onChange={() => {
            calculateAmount();
          }}/>
        </Form.Item>
        <Form.Item name="unitExpenseSoldTo" label="单位补差金额(客户承担)"
                   rules={[{required: true, message: '单位补差金额(客户承担)不能为空!'}]}>
          <WdiInputNumber min={0} onChange={() => {
            calculateAmount();
          }}/>
        </Form.Item>
        <Form.Item
          name="unitExpenseMin" label="单位补差金额(中包)"
          hidden={!ecFieldConfigs?.["unitExpense"].contain}
          rules={[{required: ecFieldConfigs?.["unitExpense"].req, message: '单位补差金额(箱/大袋)不能为空!'}]}>
          <WdiInputNumber readOnly/>
        </Form.Item>
        <Form.Item
          name="unitExpense" label="单位补差金额(箱/大袋)"
          hidden={!ecFieldConfigs?.["unitExpense"].contain}
          rules={[{required: ecFieldConfigs?.["unitExpense"].req, message: '单位补差金额(箱/大袋)不能为空!'}]}>
          <WdiInputNumber readOnly/>
        </Form.Item>
        <Form.Item
          name="priceSellinAfter" label="促销供货价(箱/大袋)"
          hidden={!ecFieldConfigs?.["priceSellinAfter"].contain}
          rules={[{required: ecFieldConfigs?.["priceSellinAfter"].req, message: '促销供货价(箱/大袋)不能为空!'}]}>
          <WdiInputNumber min={0}/>
        </Form.Item>
        <Form.Item
          name="quantityPosForecast" label="预估POS销量(箱/大袋)"
          hidden={!ecFieldConfigs?.["quantityPosForecast"].contain}
          rules={[{required: ecFieldConfigs?.["quantityPosForecast"].req, message: '预估POS销量(箱/大袋)不能为空!'}]}>
          <WdiInputNumber min={0} onChange={() => {
            calculateAmount();
          }}/>
        </Form.Item>
        <Form.Item
          name="executionRateForecast" label="转化率"
          hidden={!ecFieldConfigs?.["executionRateForecast"].contain}
          rules={[{required: ecFieldConfigs?.["executionRateForecast"].req, message: '转化率不能为空!'}]}>
          <WdiInputNumber min={0} max={100} format="p" onChange={() => {
            calculateAmount();
          }}/>
        </Form.Item>

        {buildEcFormItem("revenuePosForecast", {fieldConfig: ecFieldConfigs?.["revenuePosForecast"], readOnly: true})}

        {buildEcFormItem("activitySubjectId", {fieldConfig: ecFieldConfigs?.["activitySubjectId"]})}
        {buildEcFormItem("displayTypeIds", {fieldConfig: ecFieldConfigs?.["displayTypeIds"]})}
        {buildEcFormItem("displayQuantity", {fieldConfig: ecFieldConfigs?.["displayQuantity"]})}
        {buildEcFormItem("displayArea", {fieldConfig: ecFieldConfigs?.["displayArea"]})}
        {buildEcFormItem("targetShopQuantity", {fieldConfig: ecFieldConfigs?.["targetShopQuantity"]})}
        {buildEcFormItem("quantitySellinForecast", {fieldConfig: ecFieldConfigs?.["quantitySellinForecast"]})}
        {buildEcFormItem("revenueSellinForecast", {fieldConfig: ecFieldConfigs?.["revenueSellinForecast"]})}

        <Form.Item name="amount" label="申请金额" rules={[{required: true, message: '申请金额不能为空!'}]}>
          <WdiInputNumber min={0} readOnly/>
        </Form.Item>
        <Form.Item
          name="roiForecast" label="预计费比"
          hidden={!ecFieldConfigs?.["roiForecast"].contain}
          rules={[{required: ecFieldConfigs?.["roiForecast"].req, message: '预计费比不能为空!'}]}>
          <WdiInputNumber format={"p"} readOnly/>
        </Form.Item>

        {buildFormItem("remark")}
        {buildFormItem("ecName")}
        {buildFormItem("revenueTypeName")}
        {buildFormItem("boName")}
      </WdiModalForm>
    </>
  );
}
export default DetailPosQtySellinPriceApp;
